import { render } from "./EditProductPhotoView.vue?vue&type=template&id=694de489"
import script from "./EditProductPhotoView.vue?vue&type=script&lang=js"
export * from "./EditProductPhotoView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__